import moment from 'moment';

import { currencyFormatter } from "@helpers/formatter";

import { saveBlob } from "./download";

export const createCommissionDetailsReportCsv = async (data, storeConfig, provider, t) => {
  const { currencySymbol } = storeConfig;

  const csvData = [
    [
      `\uFEFF"${t("commissionDetailsReport_csv_date_of_fulfillment")}"`,
      `"${t("commissionDetailsReport_csv_clinic_name")}"`,
      `"${t("commissionDetailsReport_csv_amount_with_taxes")}"`,
      `"${t("commissionDetailsReport_csv_commission_rate")}"`,
      `"${t("commissionDetailsReport_csv_commission_amount_with_tax")}"`,
      `"${t("commissionDetailsReport_csv_commission_amount_without_tax")}"`,
      `"${t("commissionDetailsReport_csv_tax_amount_on_commission")}"`,
    ].join(","),
    ...data.data.map((row) => {
      return [
        `"${moment(row.order_fullfillment_date).format('YYYY/MM/DD')}"`,
        `"${provider.practiceName}"`,
        `"${currencySymbol}${parseInt(row.purchases_with_taxes)}"`,
        `"${row.commission_rate * 100}%"`,
        `"${currencySymbol}${row.commission_amount_with_tax}"`,
        `"${currencySymbol}${row.commission_amount_without_tax}"`,
        `"${currencySymbol}${row.tax_amount_on_commission}"`,
      ].join(",");
    }),
    [
      `"${t('commissionDetailsReport_Total')}"`,
      "",
      `"${currencySymbol}${parseInt(data.summary?.total_purchases_with_taxes)}"`,
      `"${t("commissionDetailsReport_NA")}"`,
      `"${currencySymbol}${data.summary?.total_commission_amount_with_tax}"`,
      `"${currencySymbol}${data.summary?.total_commission_amount_without_tax}"`,
      `"${currencySymbol}${data.summary?.tax_amount_on_commission}"`,
    ].join(",")
  ].join("\n");

  // subtracting 1 day from endDate because we want to include the endDate in the report and we have end date as next day midnight
  saveBlob(
    `${data.clinic_name}_${
      data.endDate === "Year to Date" ?
        "YTD" :
        `${moment.utc(data.startDate).format('YYYY/MM/DD')}/${moment.utc(data.endDate).subtract(1, 'days').format('YYYY/MM/DD')}`
    }.csv`,
    new Blob([csvData], { type: "text/csv;charset=utf-8," })
  );
}